import styled, { css } from "styled-components";

const commonFlexStyles = css`
	display: flex;
	justify-content: center;
	align-items: center;
`;

const commonAfterStyles = css`
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	border-radius: 0px 0px 20px 20px;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 1;
`;

const commonTitleTextStyles = css`
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 30px;
	letter-spacing: 0.938px;
	text-transform: uppercase;
	color: #fff;
	padding-left: 5px;
`;

export const BackgroundCardContainer = styled.div`
	${commonFlexStyles}
	flex-direction: column;
	height: 263px;
	width: 100%;
	position: relative;
	background-blend-mode: overlay;
	border-radius: 15px 15px 0px 0px;
	background-size: cover;
	background-repeat: no-repeat;
	border: 1px solid transparent;
	border-image-slice: 1;

	${({ hasMarsProviderBg }) =>
		!hasMarsProviderBg &&
		css`
			background: rgba(0, 0, 0, 0.2) url(${({ image }) => image}) center;
		`}

	${({ hasMarsProviderBg }) =>
		hasMarsProviderBg &&
		css`
			border: none;
			background-blend-mode: multiply, normal;
		`}

	&:after {
		${commonAfterStyles}
		background: var(--casino-lobby-active);
		mix-blend-mode: color;
	}

	${({ height }) =>
		height &&
		css`
			height: ${height};
		`}

	${({ isTransparent }) =>
		isTransparent &&
		css`
			background: url(${({ image }) => image}) center;
			background-size: cover;
			height: 263px;
			width: 100%;

			&:after {
				${commonAfterStyles}
				background: transparent;
				mix-blend-mode: unset;
			}
		`}

	.title-container {
		${commonFlexStyles}
		flex-direction: column;

		span {
			${commonTitleTextStyles}

			@media (min-width: 1024px) {
				font-size: 20px;
				font-style: normal;
				font-weight: 400;
				line-height: 30px;
				letter-spacing: 0.938px;
			}
		}
	}
`;
